const defaultAddEnterpriseGroupChange = {};
const addEnterpriseGroupChange = (state = defaultAddEnterpriseGroupChange, action) => {
  switch (action.type) {
    case 'ADD_ENTERPRISE_GROUP_CHANGE':
      return {
        ...state,
        ...{ [action.name]: action.value },
      };
    case 'CLEAR_ENTERPRISE_GROUP_CHANGE':
      return {
        ...defaultAddEnterpriseGroupChange,
      };
    default:
      return state;
  }
};

export default addEnterpriseGroupChange;
